import InfiniteScroll from "react-infinite-scroll-component";
import Pagination from "./Pagination";
import ReactPaginate from "react-paginate";
import Loader from "react-spinners/SyncLoader";
import PaginationScrollEndMsg from "./PaginationScrollEndMsg";

const MainPagination = (props) => {
  const paginationType = props.PaginationType || "paginate";
  const paginator = props.MainData?.data?.paginator;
  const pageCount = paginator?.pageCount || 0;
  const currentPage = paginator?.currentPage || 1;

  const useScrollPagination = paginationType === "scroll" && props.MainData;
  const usePaginatePagination = paginationType === "paginate" && pageCount > 1;
  const scrollableTarget = props.scrollableTarget;

  return (
    <>
      {useScrollPagination && (
        <InfiniteScroll
          dataLength={
            paginator?.slNo + paginator?.perPage - 1
          }
          next={() => {
            props.getEventsMethod(paginator?.next);
          }}
          hasMore={paginator?.hasNextPage}
          scrollableTarget={scrollableTarget}
          loader={
            <div className="event-pagination-loader">
              <Loader color="var(--event-accent, #00d4f5)" size={8} />
            </div>
          }
          endMessage={<PaginationScrollEndMsg />}
        >
          {props.children}
        </InfiniteScroll>
      )}

      {paginationType === "paginate" && props.children}

      {usePaginatePagination && (
        <Pagination>
          <ReactPaginate
            breakLabel="…"
            nextLabel={
              <>
                <span>Next</span>
                <i className="bi bi-chevron-right" aria-hidden="true"></i>
              </>
            }
            previousLabel={
              <>
                <i className="bi bi-chevron-left" aria-hidden="true"></i>
                <span>Prev</span>
              </>
            }
            onPageChange={({ selected }) => {
              props.getEventsMethod(selected + 1);
            }}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            pageCount={pageCount}
            forcePage={currentPage - 1}
            renderOnZeroPageCount={null}
            containerClassName="pagination event-pagination justify-content-center"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link page-link-nav"
            nextClassName="page-item"
            nextLinkClassName="page-link page-link-nav"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            activeClassName="active"
            disabledClassName="disabled"
          />
        </Pagination>
      )}
    </>
  );
};

export default MainPagination;
